import { CardInputWithType, ECardType, LinkInput } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

const IMPORT_KEY_COL = 'Company name';

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const regex = new RegExp(`file/d/(.*?)/view`);
    const match = regex.exec(row['Logo']);
    const imageUrl = match?.[1] ? 'https://drive.google.com/uc?id=' + match[1].trim() : null;

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row[IMPORT_KEY_COL],
            header: {
                title: row['Company name'],
                text: '',
                imageUrl
                // imageStyleId: 'stretch'
            }
        },
        cards: []
    };

    const hasLinkCard = row['URL'];
    const linkCard: CardInputWithType = {
        type: ECardType.LINK,
        links: (() => {
            const links: LinkInput[] = [];
            if (row['URL']) {
                links.push({
                    title: 'Website',
                    url: row['URL']
                });
            }
            return links;
        })()
    };

    if (hasLinkCard) {
        mutationPayload.cards.push(linkCard);
    }

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row[IMPORT_KEY_COL]?.toLowerCase();
}

export const kdagImportMethods = { duplicateChecker, parser };
